import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=3a99b8c0&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=3a99b8c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99b8c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a99b8c0')) {
      api.createRecord('3a99b8c0', component.options)
    } else {
      api.reload('3a99b8c0', component.options)
    }
    module.hot.accept("./Bottom.vue?vue&type=template&id=3a99b8c0&scoped=true", function () {
      api.rerender('3a99b8c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/layout/components/Bottom.vue"
export default component.exports